export default function isSubset(sub, sup) {
  return sub.every(val => sup.includes(val));
}
